export function buildChatRequestParams(baseParams, explicitThinkingLevel) {
  const params = { ...baseParams };
  delete params.thinking_level;
  if (typeof explicitThinkingLevel === 'string' && explicitThinkingLevel) {
    params.thinking_level = explicitThinkingLevel;
  }
  return params;
}
